// 講座班級（classNumber 1-5）對應色系，講座子頁面時程卡與 dashboard 共用
export const CLASS_BG_COLORS = {
  1: '#2EA69A',
  2: '#D9933D',
  3: '#2EA69A',
  4: '#373434',
  5: '#D96725',
}

export const DEFAULT_CLASS_COLOR = '#BC313D'
